import axios from "axios";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { ChatBotSessionResponseBodySchema } from "../schemas";
export const url = (queryParams) => {
    let qsString = "";
    if (queryParams !== null) {
        const params = new URLSearchParams();
        if (queryParams.page !== undefined) {
            params.append("page", queryParams.page.toString());
        }
        if (queryParams.pageSize !== undefined) {
            params.append("pageSize", queryParams.pageSize.toString());
        }
        if (queryParams.orderBy !== undefined) {
            params.append("orderBy", queryParams.orderBy.toString());
        }
        qsString = `?${params.toString()}`;
    }
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/chatbot/v1/sessions${qsString}`
        : `https://middleware.uat.farther.com/chatbot/v1/sessions${qsString}`;
};
const getAllChatBotSessions = async (queryParams, config) => {
    const { data } = await axios.get(url(queryParams), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            Accept: "application/json",
        },
    });
    const decoded = ChatBotSessionResponseBodySchema.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[getAllChatBotSessions] Could not parse response";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
export default getAllChatBotSessions;
//# sourceMappingURL=getAllChatBotSessions.js.map